<template>
    <v-container fluid>
        <template v-if="!isInit">
            <v-progress-linear
                indeterminate
            ></v-progress-linear>
        </template>
        <template v-else>
            <v-sheet color="rgba(0,0,0,0)" class="my-4">
                <v-img
                    class="mx-auto mb-6"
                    contain
                    src="/img/logo.svg"
                    position="center center"
                    max-width="200"
                    max-height="32"
                />
                <v-card outlined class="mx-auto rounded-lg overflow-hidden qr_wrap">
                    <v-card
                        class="d-flex flex-wrap justify-center align-center text-center pa-6"
                        :color="validQR ? 'var(--secondary-color, #3585fa)' : '#f0f0f0'"
                        width="300"
                        min-height="200"
                        elevation="0"
                        tile
                    >
                        <template v-if="validQR">
                            <p style="color: var(--secondary-text-color, #fff)">아래 QR 코드를 스캔해 주세요</p>
                            <canvas id="qrcode" class="pa-0 mt-5 qr_div"></canvas>
                        </template>
                        <p v-else>
                            {{ visitInfo ? 'QR 코드가 만료되었습니다' : '방문 신청 정보가 없습니다' }} <br>
                            다시 조회해 주세요
                        </p>
                    </v-card>
                    <template v-if="visitInfo">
                        <v-list-item two-line class="mt-3">
                            <v-list-item-content>
                                <v-list-item-subtitle>방문자</v-list-item-subtitle>
                                <v-list-item-title>{{visitor.visitorName}} {{visitor.visitorCompany}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-subtitle>접견자</v-list-item-subtitle>
                                <v-list-item-title>{{visitInfo.visitUserName}} {{visitInfo.visitDeptName}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-subtitle>접견지</v-list-item-subtitle>
                                <v-list-item-title>{{visitInfo.visitCompanyName}} {{visitInfo.visitAreaName}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-subtitle>방문예정시간</v-list-item-subtitle>
                                <v-list-item-title>{{visitInfo.startDatetime | moment('YYYY-MM-DD A hh:mm')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-card-actions>
                        <v-btn
                            v-if="validQR"
                            block
                            text
                            color="var(--primary-color, #3585fa)"
                            :to="url"
                        >
                            자세히 보기
                        </v-btn>
                        <v-btn
                            v-else
                            block
                            text
                            color="var(--primary-color, #023894)"
                            to="/home/search"
                        >
                            다시 조회하기
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-sheet>
        </template>
    </v-container>
</template>

<script>
// ref: https://www.npmjs.com/package/qrcode
import qrcode from 'qrcode';
import {mapState} from "vuex";
import ApplyActionMixin from "@/components/apply/ApplyActionMixin";

export default {
    name: 'Qrcode',
    mixins: [ApplyActionMixin],

    data: () => ({
        isInit: false,
        encryptedVisitId: null,
        encryptedVisitorId: null,
        url: null,
        visitInfo: null,
        visitor: null,
        validQR: false,
    }),

    computed: {
        ...mapState(['secretKey', 'iv']),
    },

    async mounted() {
        this.encryptedVisitId = this.$route.params.encryptedVisitId;
        this.encryptedVisitorId = this.$route.params.encryptedVisitorId;
        this.url = `/home/visitInfo/f/${this.encryptedVisitId}/${this.encryptedVisitorId}`;

        await this.fetchData();
        const canvas = document.getElementById("qrcode");
        const qrData = this.encryptedVisitId + "@" + this.encryptedVisitorId;

        qrcode.toCanvas(canvas,
            qrData,
            {
                width: 250,
                height: 250,
            },
            err => {
                if (err) {
                    console.error(err);
                    this.$window.alert('QR코드 생성 오류', 'error')
                }
            }
        );
    },

    methods: {
        async fetchData() {
            try {
                const res = await this.$axios.post('/v1/home/visit/visitorInfo', {
                    visitId: this.encryptedVisitId,
                    visitorId: this.encryptedVisitorId
                });
                this.visitInfo = res.data.visitInfo;
                this.visitor = res.data.visitor;
                const today = this.$moment();
                const startDate = this.$moment(this.visitInfo.startDatetime);
                this.validQR = today.isSameOrBefore(startDate,'day');
            } catch(err) {
                console.error(err);
            } finally {
                this.isInit = true;
            }
        }
    }
}
</script>

<style lang="scss">
</style>
